<div class="py-4 container-fluid subject-management-create-page">
  <h4 class="mb-4 subject-management-create-title">การจัดการรายวิชา</h4>

  <div class="subject-management-create-card">
    <div class="subject-management-create-card-body">
      <app-subject-info-form
        [subjectForm]="subjectForm"
        [isSaved]="isSaved"
        [subjectApprovalStatusLabel]="subjectApprovalStatusLabel"
        [subjectApprovalStatus]="subjectApprovalStatus"
        [academicTermOptions]="academicTermOptions"
        [yearOptions]="yearOptions"
        [subjectTypeOptions]="subjectTypeOptions"
        [subjectOptions]="subjectOptions"
        [curriculumTypeOptions]="curriculumTypeOptions"
        [submitted]="submitted"
        (requestSave)="onRequestSaveSubject()"
        (requestDelete)="onRequestDeleteSubject()"
      ></app-subject-info-form>

      <div class="subject-management-create-section-area" *ngIf="isSaved">
        <div class="subject-management-create-section-toolbar">
          <button type="button" class="app-button app-button-primary subject-management-create-add-section-button"
            (click)="onAddSection()">
            <img src="assets/media/icons/svg/add-item.svg" alt="" aria-hidden="true" />
            <span>เพิ่ม Section</span>
          </button>
        </div>

        <form [formGroup]="sectionsForm">
          <app-section-editor
            *ngFor="let section of sectionForms; let i = index"
            [section]="section"
            [sectionIndex]="i"
            [teachingTypeOptions]="teachingTypeOptions"
            [teachingDayOptions]="teachingDayOptions"
            [timeOptions]="timeOptions"
            [teachers]="getSectionTeachers(i)"
            [workloadMode]="getTeacherWorkloadModeForSection(i)"
            [isProjectResearch]="isProjectResearchSubjectType()"
            [workloadHoursEditable]="false"
            [locked]="isTeacherSectionLocked(i)"
            [submitted]="isSectionSubmitted(i)"
            [statusLabel]="getSectionStatusLabel(i)"
            [status]="getSectionStatus(i)"
            [approvalReady]="isSectionReadyForApproval(i)"
            [isSubmittingApproval]="isSubmittingApproval"
            [showTopStatusBadge]="false"
            [saveMode]="!isSectionSubmitted(i)"
            [collapsible]="isSectionSubmitted(i)"
            [expanded]="isSectionExpanded(i)"
            (requestRemove)="onRequestRemoveSection(i)"
            (expandedChange)="onSectionExpandedChange(i, $event)"
            (addTeachingTime)="onAddTeachingTime(i)"
            (removeTeachingTime)="onRemoveTeachingTime(i, $event)"
            (manageTeachers)="onManageTeachers(i)"
            (editProjectTeacher)="onEditProjectTeacher(i, $event)"
            (removeProjectTeacher)="onRemoveProjectTeacher(i, $event)"
            (saveSection)="onSaveSection(i)"
            (submitApproval)="onSubmitApproval(i)"
          ></app-section-editor>
        </form>
      </div>
    </div>
  </div>
</div>

<app-project-teacher-modal
  [projectTeacherForm]="projectTeacherForm"
  [projectTeachingTimes]="projectTeachingTimes"
  [teacherOptions]="teacherOptions"
  [teachingDayOptions]="teachingDayOptions"
  [timeOptions]="timeOptions"
  [projectTeacherSubmitted]="projectTeacherSubmitted"
  (projectTeacherSelected)="onProjectTeacherSelected($event)"
  (addTeachingTime)="onAddProjectTeachingTime()"
  (removeTeachingTime)="onRemoveProjectTeachingTime($event)"
  (teachingTimeChanged)="updateProjectWorkloadHours()"
  (saveProjectTeacher)="onSaveProjectTeacher()"
  (cancelProjectTeacher)="onCancelProjectTeacher()"
></app-project-teacher-modal>

<app-confirm-dialog #deleteSectionConfirmDialog modalId="deleteSectionConfirmDialog" title="ยืนยันการลบรายการ"
  message="คุณต้องการลบ Section นี้ใช่หรือไม่ ?" cancelText="ยกเลิก" confirmText="ยืนยัน"
  (confirmed)="onConfirmRemoveSection()" (cancelled)="onCancelRemoveSection()"></app-confirm-dialog>

<app-confirm-dialog #saveSubjectConfirmDialog modalId="saveSubjectConfirmDialog" title="ยืนยันการสร้างรายวิชา"
  message="โปรดตรวจสอบความถูกต้องของข้อมูลก่อนดำเนินการยืนยัน เนื่องจากจะไม่สามารถแก้ไขข้อมูลภายหลังได้"
  cancelText="ยกเลิก" icon="warning" confirmText="ยืนยัน" (confirmed)="onSaveSubject()"></app-confirm-dialog>

<app-confirm-dialog #saveSubjectErrorDialog modalId="saveSubjectErrorDialog" title="ไม่สามารถบันทึกข้อมูลได้"
  [message]="saveSubjectErrorMessage" icon="warning" confirmText="ปิด" [showCancelButton]="false"
  (confirmed)="saveSubjectErrorDialog.close()"></app-confirm-dialog>

<app-confirm-dialog #deleteSubjectConfirmDialog modalId="deleteSubjectConfirmDialog" title="ยืนยันการลบรายวิชา"
  message="คุณต้องการลบรายวิชานี้ใช่หรือไม่ ?" cancelText="ยกเลิก" confirmText="ยืนยัน"
  (confirmed)="onConfirmDeleteSubject()"></app-confirm-dialog>

<app-confirm-dialog #teacherSectionLockConfirmDialog modalId="teacherSectionLockConfirmDialog"
  title="ยืนยันการล็อกข้อมูล Section"
  message="เมื่อยืนยันแล้วจะไม่สามารถแก้ไขข้อมูล Section และวันเวลาสอนได้ ต้องการดำเนินการต่อหรือไม่ ?"
  cancelText="ยกเลิก" icon="warning" confirmText="ยืนยัน" (confirmed)="onConfirmTeacherSectionLock()"
  (cancelled)="onCancelTeacherSectionLock()"></app-confirm-dialog>

<app-confirm-dialog #submitApprovalConfirmDialog modalId="submitApprovalConfirmDialog" title="ยืนยันการส่งขอรับรอง"
  message="โปรดตรวจสอบข้อมูลก่อนส่งขอรับรอง ต้องการดำเนินการต่อหรือไม่ ?" cancelText="ยกเลิก"
  icon="warning" confirmText="ยืนยัน" [isProcessing]="isSubmittingApproval" (confirmed)="onConfirmSubmitApproval()"
  (cancelled)="onCancelSubmitApproval()"></app-confirm-dialog>

<app-confirm-dialog #submitApprovalErrorDialog modalId="submitApprovalErrorDialog" title="ไม่สามารถส่งขอรับรองได้"
  [message]="submitApprovalErrorMessage" icon="warning" confirmText="ปิด" [showCancelButton]="false"
  (confirmed)="submitApprovalErrorDialog.close()"></app-confirm-dialog>

<app-confirm-dialog #submitApprovalSuccessDialog modalId="submitApprovalSuccessDialog" title="ส่งขอรับรองสำเร็จ"
  message="ดำเนินการส่งขอรับรองสำเร็จ" icon="success" confirmText="ปิด" [showCancelButton]="false"
  (confirmed)="submitApprovalSuccessDialog.close()"></app-confirm-dialog>

<app-teacher-management-modal
  [teacherModalForm]="teacherModalForm"
  [teacherDraftRows]="teacherDraftRows"
  [teacherOptions]="teacherOptions"
  [teacherTeachingRangeOptions]="teacherTeachingRangeOptions"
  [teachingTimes]="activeTeacherSectionIndex === null ? [] : getTeachingTimeValues(activeTeacherSectionIndex)"
  [workloadHoursText]="activeTeacherSectionIndex === null ? '-' : getWorkloadHoursText(activeTeacherSectionIndex)"
  (addTeacher)="onAddTeacherDraftRow()"
  (removeTeacher)="onRemoveTeacherDraftRow($event)"
  (teacherSelected)="onTeacherSelected($event.rowIndex, $event.teacher)"
  (saveTeachers)="onSaveTeachers()"
  (cancelTeachers)="onCancelTeachers()"
></app-teacher-management-modal>

<app-confirm-dialog #deleteItemWarningDialog modalId="subjectManagementCreateDeleteItemWarningDialog"
  title="ยืนยันการลบรายการ" [message]="pendingDeleteMessage" cancelText="ยกเลิก" confirmText="ลบ"
  icon="trash" [stackAboveModal]="true" (confirmed)="onConfirmPendingDelete()"
  (cancelled)="onCancelPendingDelete()"></app-confirm-dialog>
